import { colors } from '@alixpartners/ui-components';
import { generateHighchartStyles } from 'Investigate/WaterfallChart/WaterfallChart.styles';
import styled, { css } from 'styled-components';

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	padding: 12.5% 0;
`;

export const NoData = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	letter-spacing: 0.3px;
	padding: 32px 0 32px 4px;
`;

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	padding: 24px 32px;
	margin: auto;
	width: 1135px;
	background-color: #ffffff;
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	button:first-child {
		height: 32px;
	}
	margin-bottom: 25px;
	margin-top: 1%;
`;

export const Label = styled.div`
	font-size: 12px;
	line-height: 38px;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	button {
		height: 30px;
		width: 40px;
	}
	span {
		font-size: 10px;
	}
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 19px;
	color: #000000;
	flex: 1;
`;

export const Breadcrumbs = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	margin-top: 20px;
	margin-left: 10px;
	font-size: 12px;
	letter-spacing: 0.3px;
	color: ${colors.grey6};
	padding-bottom: 20px;
	span {
		cursor: pointer;
		font-size: 12px;

		text-decoration: underline;
	}

	span:hover {
		cursor: pointer;
		color: ${colors.grey9};
	}
`;

export const Wrapper = styled.div`
	z-index: 1;
	position: relative;

	display: flex;
	flex-direction: column;
	margin-top: 23px;
	margin-right: -10px;
	padding-left: 3px;

	${generateHighchartStyles};
`;
export const HighlightBlock = styled.div`
	opacity: 0;
	cursor: pointer;
	box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);
	background-color: transparent;

	position: absolute;
	top: 0;
	bottom: 0;

	${({ width, left }) =>
		css`
			width: ${width}px;
			left: ${left}px;
		`};

	${({ isActive, isHighlight }) =>
		(isActive || isHighlight) &&
		css`
			opacity: 1;
		`};

	& > div:first-child {
		right: 0;
		top: 4px;
	}
`;
export const HighlightBlockWrapper = styled.div`
	position: absolute;
	top: -20px;
	background-color: transparent;

	${({ width, height, left }) =>
		css`
			width: ${width}px;
			height: ${height}px;
			left: ${left + 3}px;
		`};

	${({ isActive }) =>
		isActive &&
		css`
			${HighlightBlock}:hover {
				opacity: 1;
			}
		`};
`;
